import { Injector } from "../../di/Injector"
import { noop } from "../../saga/noop"
import { BlackBoxGenerator } from "../../saga/types"
import { debounce } from "../../time/debounce"
import { setWindow } from "../actions"

export function* watchWindowResize({ win, store }: Injector): BlackBoxGenerator {
  win.addEventListener(
    "resize",
    debounce(function (this: Window) {
      store.dispatch(
        setWindow({
          height: this.innerHeight,
          width: this.innerWidth
        })
      )
    }, 50)
  )

  yield* noop()
}
